module.exports = __webpack_public_path__ + "img/grey-tick.1141f4a7.svg";